<template>
  <div>
    <app-breadcrumb>
      <template #contentright>
        <b-button
          variant="success"
          :to="{ name: 'collection-create' }"
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }}
          </span>
        </b-button>
      </template>
    </app-breadcrumb>
    <div class="row">
      <div class="col-12 col-md-5">
        <div class="card">
          <div class="card-body">
            <validation-observer ref="collection">
              <b-form
                ref="collectionForm"
                class="collectionForm"
                @submit.prevent=""
                @reset.prevent="resetForm"
              >

                <validation-provider
                  #default="validationContext"
                  vid="name"
                  name="Tên nhóm đối tượng"
                  rules="required"
                >
                  <b-form-group>
                    <template #label>
                      <label class="d-block font-weight-bolder pb-0">Tên nhóm đối tượng <span class="text-danger">*</span></label>
                    </template>
                    <b-form-input
                      id="name"
                      v-model="frmData.name"
                      type="text"
                      :state="getValidationState(validationContext)"
                      placeholder="Nhập..."
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>

                  </b-form-group>
                </validation-provider>
                <b-form-group
                  label="Mô tả"
                  label-for="textarea"
                >
                  <b-form-input
                    id="textarea"
                    v-model="frmData.desc"
                    type="text"
                    placeholder="Nhập mô tả..."
                  />
                </b-form-group>
                <b-form-checkbox
                  v-model="frmData.status"
                  value="1"
                  class="custom-control-primary"
                >
                  Kích hoạt
                </b-form-checkbox>
                <div class="d-flex mt-2">
                  <b-button
                    variant="primary"
                    type="submit"
                    @click.prevent="validationForm"
                  >
                    {{ $t('Save') }}
                  </b-button>
                </div>
              </b-form>
            </validation-observer>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-7">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              Nhóm danh mục
            </h4>
          </div>
          <div class="card-body">
            <DxTreeView
              id="treeview"
              ref="treeView"
              :items="dataCategory"
              show-check-boxes-mode="selectAll"
              selection-mode="multiple"
              :select-nodes-recursive="true"
              :select-by-click="true"
              :search-enabled="true"
              search-mode="contains"
              @selection-changed="treeViewSelectionChanged"
              @content-ready="treeViewContentReady"
            >
              <template #item="item">
                {{ item.data.text }}
              </template>
            </DxTreeView>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  required, email, alphaNum, min, max,
} from '@validations'
import store from '@/store'
import { ref, watch, onMounted } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BFormCheckbox, BTable,
} from 'bootstrap-vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import { showToast, useRouter } from '@core/utils/utils';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import DxTreeView from 'devextreme-vue/tree-view';
import DxList from 'devextreme-vue/list';
import DxCheckBox from 'devextreme-vue/check-box';
import 'devextreme/dist/css/dx.light.css';

export default {

  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    Ripple,
    BTable,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    AppBreadcrumb,
    DxTreeView,
    DxList,
    DxCheckBox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      selectedEmployees: [],
    };
  },
  computed: {
    treeView() {
      return this.$refs.treeView.instance;
    },
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const dataListState = ref([])
    const dataCategory = ref([]);
    const category_id = ref([]);

    const blankData = {
      id: '',
      name: '',
      desc: '',
      items: [],
      status: 0,
    }
    const frmData = ref(JSON.parse(JSON.stringify(blankData)))
    const resetfrmData = () => {
      frmData.value = JSON.parse(JSON.stringify(blankData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(frmData)

    const fetchDataListState = () => {
      store.dispatch('state/fetchAll', { type: 'all' })
        .then(response => {
          if (response.data.code === 200) {
            dataListState.value = response.data.data
          }
        })
    }
    fetchDataListState();
    const fetchData = () => {
      store.dispatch('collection/show', { id: id.value })
        .then(response => {
          const result = response.data
          if (result.code === 200) {
            const category_id = result.data.category_id.join(',')
            frmData.value = result.data
            all_cats(category_id)
          }
        })
    }

    const all_cats = (category_id) => {
      store.dispatch('category/fetchAll', { type: 'news', style: 2, category_id })
        .then(response => {
          const result = response.data;
          if (result.code === 200) {
            const items = result.data;
            dataCategory.value = items;
          }
        })
    }

    if (id.value) {
      fetchData();
    } else {
      all_cats();
    }

    watch(
      () => context.root.$route,
      (to) => {
        if (to.name === 'collection-create') {
          resetfrmData();
          all_cats()
        } else {
          fetchData();
        }
      },
    )

    return {
      frmData,
      refFormObserver,
      resetForm,
      getValidationState,
      resetfrmData,
      dataListState,
      dataCategory,

    }
  },
  methods: {
    treeViewSelectionChanged(e) {
      this.syncSelection(e.component);
    },

    treeViewContentReady(e) {
      this.syncSelection(e.component);
    },

    syncSelection(treeView) {
      const selectedEmployees = treeView.getSelectedNodes()
        .map((node) => node.itemData);
      this.frmData.items = selectedEmployees;
    },
    onSubmit() {
      const { id } = this.frmData;
      if (id) {
        store.dispatch('collection/update', { data: this.frmData, id })
          .then(response => {
            const result = response.data;
            if (result.code === 200) {
              showToast(result.message, { variant: 'success' });
            } else if (result.errors) {
              this.$refs.collection.setErrors(result.errors)
              this.errorMessage = result.errors;
            } else {
              showToast(result.message);
            }
          })
      } else {
        store.dispatch('collection/create', this.frmData)
          .then(response => {
            const result = response.data;
            if (result.code === 200) {
              showToast(result.message, { variant: 'success' });
              this.resetfrmData()
              this.$router.push({ name: 'collection-list' });
            } else if (result.errors) {
              this.$refs.collection.setErrors(result.errors)
            } else {
              showToast(result.message);
            }
          })
      }
    },
    validationForm() {
      this.errorMessage = {}
      this.$refs.collection.validate().then(success => {
        if (success) {
          this.onSubmit();
        }
      })
    },
  },
}
</script>
